import { toCleanPairSymbol } from "@cede/types";
import { DEFAULT_UNDEFINED_STRING } from "../constants";
import { parsePairSymbol } from "./parsePairSymbol";

/**
 * Arena favorite key: uppercased and settled in its quote ("kPEPE", "USDC" → "KPEPE/USDC:USDC").
 * The API stores stars under it and the arena looks them up by it, so both build it here.
 */
export function arenaFavoritePairSymbol(base: string, quote: string): string {
  const upperQuote = quote.toUpperCase();
  return `${base.toUpperCase()}/${upperQuote}:${upperQuote}`;
}

/** The favorite key of a raw pair, venue prefix dropped ("xyz:gold/USDC:USDC" → "GOLD/USDC:USDC"). Null when malformed. */
export function toArenaFavoritePairSymbol(pairSymbol: string): string | null {
  const { base, quote } = parsePairSymbol(toCleanPairSymbol(pairSymbol));
  if (base === DEFAULT_UNDEFINED_STRING || quote === DEFAULT_UNDEFINED_STRING) return null;
  return arenaFavoritePairSymbol(base, quote);
}
